const config = {
  siteTitle: "mcnimbus.org",
  siteTitleShort: "mcnimbus",
  siteTitleAlt: "mcnimbus",
  siteLogo: "/logos/mcnimbus_dark_88.png",
  siteUrl: "https://www.mcnimbus.org",
  userTwitter: "hiswhitestone",
  menuLinks: [
    {
      name: "Articles",
      link: "/articles/",
    },
    {
      name: "About",
      link: "/about/",
    },
  ],
}

module.exports = config
